import { useEffect, useState } from "react";
import { useTimeout } from "Context/TimeoutContext";

const useDebounce = (value: string, delay: number) => {
  const { set, clear } = useTimeout();
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [debouncedLoading, setDebouncedLoading] = useState(false);

  useEffect(
    () => {
      setDebouncedLoading(true);

      clear("debounceTimeout");

      set("debounceTimeout", () => {
        setDebouncedValue(value);
        setDebouncedLoading(false);
      }, delay);

      return () => {
        clear("debounceTimeout");
        setDebouncedLoading(false);
      };
    },
    [value, delay, clear, set]
  );

  return { debouncedValue, debouncedLoading };
}

export default useDebounce;
